import { AnyAction } from 'redux';
import { App, Produkt, Produktlinie, VhvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { produktReducer } from '@ps20-frontend/reducers';
import { FahrradWert, Produktlinienname } from '@ps20/bff-models';
import { VhvActions } from '../vhvActions';
import { IAppState } from '../appState';
import { ZUSATZOPTION_FAHRRAD_ID } from '../model/fahradwertForLinie.model';

export const vhvProduktReducer = function (
  sectionState: Produkt = null,
  action: AnyAction,
  state: IAppState,
): Produkt {
  const newSectionState: Produkt = produktReducer(sectionState, action, App.VHV, state?.angebotsId);

  switch (action.type) {
    case VhvActions.BRUTTOPREISE_CALCULATED:
    case VhvActions.PRODUKTLINIEN_CHANGED: {
      const produktlinien: Produktlinie[] = action.payload;
      return { ...newSectionState, produktlinien };
    }
    case VhvActions.PRODUKT_ZUSATZOPTIONEN_VORBELEGT: {
      const relevantVorbelegungdaten: VhvVorbelegungdaten = action.payload;
      const produktlinien: Produktlinie[] = newSectionState?.produktlinien;
      const newProduktLinien = produktlinien?.map(produktlinie => {
        if (produktlinie.zusatzoptionen) {
          produktlinie.zusatzoptionen.forEach(zusatzoption => {
            if (relevantVorbelegungdaten?.vorvertragBausteinList) {
              const vorbelegteZusatzOptionFound =
                relevantVorbelegungdaten.vorvertragBausteinList.find(
                  zo => zo?.taasTarifrisikoschluessel === zusatzoption?.name,
                );
              if (vorbelegteZusatzOptionFound) {
                zusatzoption.isSelected = true;
                if (
                  vorbelegteZusatzOptionFound.taasTarifrisikoschluessel === 'FAHRRAD' &&
                  produktlinie.produktName !== Produktlinienname.PREMIUM
                ) {
                  zusatzoption.eigenschaft = relevantVorbelegungdaten.fahrradWert;
                }
              }
              return zusatzoption;
            }
          });
        }
        return produktlinie;
      });
      return { ...newSectionState, produktlinien: newProduktLinien };
    }
    case VhvActions.VERSSUMME_FAHRRAD_CHANGED: {
      const actionPayload: FahrradWert = action.payload;
      const newProduktLinien = newSectionState.produktlinien.map(produktlinie => {
        if (produktlinie.zusatzoptionen) {
          produktlinie.zusatzoptionen = produktlinie.zusatzoptionen.map(zusatzoption => {
            if (zusatzoption.id === ZUSATZOPTION_FAHRRAD_ID) {
              return { ...zusatzoption, eigenschaft: actionPayload };
            }
            return zusatzoption;
          });
        }
        return produktlinie;
      });
      return { ...newSectionState, produktlinien: newProduktLinien };
    }
    default:
      return newSectionState;
  }
};
